import classNames from 'classnames';
import { useField, ErrorMessage } from 'formik';
import ReactHtmlParser from 'react-html-parser';

const Checkboxes = ({ options, split, parse, ...props }) => {
	const [field, meta] = useField(props);
	return (
		<div className='form__group' role='group' aria-label='checkboxes'>
			<div
				className={classNames('form__validation', {
					'form__validation--error': meta.touched && meta.error,
					'grid-md-2 row-gap-0': split,
				})}
			>
				{options.map(option => {
					return (
						<label key={option.value} className='form__item'>
							<input
								className='form__selector'
								type='checkbox'
								{...field}
								{...props}
								value={option.value}
							/>
							<div className='form__check'></div>
							{parse ? ReactHtmlParser(option.label) : option.label}
						</label>
					);
				})}
				<ErrorMessage name={field.name} render={msg => <div className='form__helper'>{msg}</div>} />
			</div>
		</div>
	);
};

export default Checkboxes;
